/** Client-safe locale constants (no next/headers). */
export const LOCALE_COOKIE = 'NEXT_LOCALE'
export const LOCALE_MAX_AGE = 60 * 60 * 24 * 365
